import script from "./StreamdeckStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./StreamdeckStatus.vue?vue&type=script&lang=ts&setup=true"

import "./StreamdeckStatus.vue?vue&type=style&index=0&id=20dc48c0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20dc48c0"]])

export default __exports__